// @flow
import React, { useContext } from 'react';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';

import { type AwardProps } from 'Components/widgets/tripadvisor-awards/TripAdvisorAwards.jsx';
import { type TripAdvisorRatingsProps } from 'Components/widgets/tripadvisor-ratings/TripAdvisorRatings.jsx';
import { type ReviewProps } from 'Components/widgets/tripadvisor-reviews/TripAdvisorReviews.jsx';

import { TripAdvisorLarge } from 'Components/widgets/tripadvisor-large/TripAdvisorLarge.jsx';
import { TripAdvisorNarrow } from 'Components/widgets/tripadvisor-narrow/TripAdvisorNarrow.jsx';

type Props = {|
  awards?: Array<AwardProps>,
  awardsLabel?: string,
  ratings?: TripAdvisorRatingsProps,
  ratingsLabel?: string,
  reviews?: Array<ReviewProps>,
  reviewsLabel?: string,
|};

export function TripAdvisor(props: Props) {
  const { isDesktop } = useContext(ResponsiveContext);
  return isDesktop ? <TripAdvisorLarge {...props} /> : <TripAdvisorNarrow {...props} />;
}
